export const removeClassByPrefix = (node: HTMLElement, prefix: string) => {
  const regex = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
  node.className = node.className.replace(regex, '');
  return node;
};
